import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import LoginForm from "./LoginForm";
import { useDispatch, useSelector } from 'react-redux';
import appActions from '../../../appActions';
import storage from "../../../utils/storage";
import { Toast } from "primereact/toast";
import { clearToast } from "../../../utils/toastReducer";

const Login = () => {

    const toast = useRef(null);  

    let navigate = useNavigate();
    const dispatch = useDispatch();
    const [loginData, setLogindata] = useState({})

    const authToken = useSelector((state) => state.auth.authToken);
    const error = useSelector((state) => state.auth.error);

    const toastMessage = useSelector((state) => state.toast.toastMessage);

    // Show toast whenever there's a new message
    useEffect(() => {
       if (toastMessage && toast?.current) {
           toast.current.show({
               severity: toastMessage?.severity,
               summary: toastMessage?.summary,
               detail: toastMessage?.detail,
               life: 3000, // Auto hide after 3 seconds
           });

           // Clear the toast after showing it
           dispatch(clearToast());
       }
   }, [toastMessage, dispatch]);


    const user = useSelector(state => state.auth.user)

    useEffect(() => {
        if (authToken) {
            dispatch(appActions.USER_GET_ALL_REQUEST({userId: loginData.userid}))
            
        }
    }, [authToken])

    useEffect(() => {
        if (user && user.userId) {
            storage.set('userId', user.userId)
            storage.set('loginUser', JSON.stringify(user))
            navigate("/ui/task", { replace: true });
        }
    }, [user])

    const handleLogin = (data) => {
        setLogindata(data)
        dispatch(appActions.AUTH_CREATE_REQUEST(data));
    }

    const renderLoginForm = () => {
        return (
            <>
                <Toast ref={toast} />
                <div className="h-100">
                    <div className="grid h-100 mt-0">
                        <div className="col-12 xl:col-6 leftSpace" />
                        <div className="col-12 xl:col-6 flex align-items-center justify-content-center">
                            <LoginForm onClickLoginBtn={handleLogin} error={error} />
                        </div>
                    </div>
                </div>
            </>
        )
    }

    return renderLoginForm();
};

export default Login;
